module.exports = __webpack_public_path__ + "img/OBCINA RACE-FRAM.33f196e3.png";